import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';
import starIcon from 'assets/img/star.svg';

const useStyles = makeStyles((theme) => ({
  card: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '30px',
    borderRadius: '15px',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    backdropFilter: 'blur(10px)',
    transition: 'opacity 0.5s ease, transform 0.5s ease',
    opacity: 0,
    transform: 'translateY(20px)',
    visibility: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  },
  visible: {
    opacity: 1,
    transform: 'translateY(0)',
    visibility: 'visible'
  },
  quote: {
    color: '#fff',
    fontSize: '24px',
    lineHeight: 1.6,
    marginBottom: '20px',
    fontStyle: 'italic',
    textAlign: 'center'
  },
  author: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px'
  },
  avatar: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    objectFit: 'cover'
  },
  authorInfo: {
    textAlign: 'left'
  },
  username: {
    color: '#fff',
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: '4px'
  },
  level: {
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '14px'
  },
  rating: {
    display: 'flex',
    gap: '5px',
    marginTop: '10px'
  },
  star: {
    width: '20px',
    height: '20px'
  }
}));

const TestimonialCard = ({ quote, username, level, avatar, isVisible, align = 'left', rating = 5 }) => {
  const classes = useStyles();

  return (
    <div
      style={{
        opacity: isVisible ? 1 : 0,
        transform: `translateX(${isVisible ? 0 : (align === 'left' ? -100 : 100)}px)`,
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        transition: 'all 0.5s ease-in-out',
        display: 'flex',
        flexDirection: 'column',
        alignItems: align === 'left' ? 'flex-start' : 'flex-end',
        padding: '20px',
        color: '#fff',
        textAlign: align,
        pointerEvents: isVisible ? 'auto' : 'none',
      }}
    >
      <div
        style={{
          
          borderRadius: '15px',
          padding: '20px',
          maxWidth: '600px',
          width: '100%',
          marginBottom: '20px',
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: '10px',
            marginBottom: '10px',
            justifyContent: align === 'left' ? 'flex-start' : 'flex-end',
          }}
        >
          {[...Array(rating)].map((_, index) => (
            <img
              key={index}
              src={starIcon}
              alt="star"
              style={{
                width: '20px',
                height: '20px',
              }}
            />
          ))}
        </div>
        <p
          style={{
            fontSize: '18px',
            lineHeight: '1.6',
            marginBottom: '15px',
            fontStyle: 'italic',
          }}
        >
          "{quote}"
        </p>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            justifyContent: align === 'left' ? 'flex-start' : 'flex-end',
          }}
        >
          <img
            src={avatar}
            alt={username}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          />
          <div>
            <p
              style={{
                fontWeight: 'bold',
                margin: '0',
              }}
            >
              {username}
            </p>
            <p
              style={{
                margin: '0',
                fontSize: '14px',
                opacity: 0.8,
              }}
            >
              {level}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard; 